// Faz BN — token değerlerini CSS değişkenleri olarak DOM'a yazar.
// MUI dışı consumer'lar (mevcut hardcoded sayfalar, özel CSS) için.
import { tokensForMode, sidebarTokens, spacing, radius, shadow, motion } from "./tokens";

function setVar(el, name, value) {
  el.style.setProperty(name, String(value));
}

export function applyCssVars(mode = "light") {
  if (typeof document === "undefined") return;
  const el = document.documentElement;
  const t = tokensForMode(mode);

  Object.entries(t).forEach(([k, v]) => {
    const kebab = k.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);
    setVar(el, `--color-${kebab}`, v);
  });

  Object.entries(sidebarTokens).forEach(([k, v]) => {
    const kebab = k.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);
    setVar(el, `--sidebar-${kebab}`, v);
  });

  Object.entries(spacing).forEach(([k, v]) => setVar(el, `--space-${k}`, `${v}px`));
  Object.entries(radius).forEach(([k, v]) => setVar(el, `--radius-${k}`, typeof v === "number" ? `${v}px` : v));
  Object.entries(shadow).forEach(([k, v]) => setVar(el, `--shadow-${k}`, v));
  Object.entries(motion).forEach(([k, v]) => setVar(el, `--motion-${k}`, v));

  el.setAttribute("data-theme", mode);
  el.style.colorScheme = mode;
}
